(function () {
  function whenThreeReady(cb, tries) {
    tries = tries || 0;
    if (window.THREE && window.THREE.GLTFLoader) { cb(); return; }
    if (tries > 200) return;
    setTimeout(function () { whenThreeReady(cb, tries + 1); }, 50);
  }

  function buildPlaceholder(THREE, variant, built) {
    var stoneMat = new THREE.MeshStandardMaterial({ color: built ? 0x3a3d44 : 0x232529, roughness: 0.95, metalness: 0.02 });
    var accentMat = new THREE.MeshStandardMaterial({ color: 0x83baca, roughness: 0.4, metalness: 0.1 });
    var heights = [4.9, 4.0, 5.7, 3.2, 5.3, 4.4, 5.9, 3.6, 4.8];
    var h = heights[variant % heights.length], w = 3.2, d = 2.8;
    var group = new THREE.Group();
    if (built) {
      var bodyH = h * 0.78;
      var body = new THREE.Mesh(new THREE.BoxGeometry(w, bodyH, d), stoneMat); body.position.y = bodyH / 2; group.add(body);
      var roof = new THREE.Mesh(new THREE.ConeGeometry(w * 0.78, h * 0.32, 4), stoneMat); roof.rotation.y = Math.PI / 4; roof.position.y = bodyH + (h * 0.32) / 2; group.add(roof);
      var door = new THREE.Mesh(new THREE.BoxGeometry(0.7, 1.2, 0.14), accentMat); door.position.set(0, 0.6, d / 2 + 0.06); group.add(door);
      for (var i = -1; i <= 1; i += 2) { var col = new THREE.Mesh(new THREE.CylinderGeometry(0.1, 0.1, bodyH * 0.9, 8), stoneMat); col.position.set(i * (w / 2 - 0.2), bodyH * 0.45, d / 2 - 0.06); group.add(col); }
    } else {
      var brokenH = h * (0.12 + (variant % 4) * 0.035);
      var body = new THREE.Mesh(new THREE.BoxGeometry(w, brokenH, d), stoneMat); body.position.y = brokenH / 2; body.rotation.y = (variant % 3) * 0.04 - 0.04; group.add(body);
      for (var r = 0; r < 4 + (variant % 3); r++) { var sz = 0.3 + Math.random() * 0.4; var rub = new THREE.Mesh(new THREE.BoxGeometry(sz, sz, sz), stoneMat); var ang = Math.random() * Math.PI * 2; var dist = w / 2 + Math.random() * 1.6; rub.position.set(Math.cos(ang) * dist, sz / 2, Math.sin(ang) * dist); rub.rotation.set(Math.random(), Math.random(), Math.random()); group.add(rub); }
      var ivyMat = new THREE.MeshStandardMaterial({ color: 0x2f5b3f, roughness: 1 });
      for (var iv = 0; iv < 2 + (variant % 3); iv++) { var ivy = new THREE.Mesh(new THREE.SphereGeometry(0.24 + Math.random() * 0.2, 6, 6), ivyMat); ivy.position.set((Math.random() - 0.5) * w * 0.8, Math.random() * brokenH * 0.6 + brokenH * 0.3, d / 2 - 0.1); group.add(ivy); }
    }
    return group;
  }

  function buildRock(THREE) {
    var s = 0.3 + Math.random() * 0.7;
    var rock = new THREE.Mesh(new THREE.IcosahedronGeometry(s, 0), new THREE.MeshStandardMaterial({ color: 0x22242b, roughness: 1 }));
    rock.position.y = s * 0.4; rock.rotation.set(Math.random(), Math.random(), Math.random());
    return rock;
  }

  function buildRockField(THREE, innerRadius) {
    var group = new THREE.Group();
    for (var f = 0; f < 55; f++) {
      var angle = Math.random() * Math.PI * 2;
      var dist = innerRadius + 10 + Math.random() * 30;
      var item = buildRock(THREE);
      item.position.set(Math.sin(angle) * dist, 0, -Math.cos(angle) * dist);
      item.scale.setScalar(0.7 + Math.random() * 0.9);
      item.rotation.y = Math.random() * Math.PI * 2;
      group.add(item);
    }
    return group;
  }

  function computeMeshBoundingBox(THREE, root) {
    var box = new THREE.Box3(), hasMesh = false;
    root.updateMatrixWorld(true);
    root.traverse(function (child) {
      if (child.isMesh && child.geometry) {
        child.geometry.computeBoundingBox();
        var cb = child.geometry.boundingBox.clone().applyMatrix4(child.matrixWorld);
        if (!hasMesh) { box.copy(cb); hasMesh = true; } else { box.union(cb); }
      }
    });
    if (!hasMesh) box.setFromObject(root);
    return box;
  }

  function desaturateModel(THREE, root) {
    root.traverse(function (child) {
      if (!child.isMesh || !child.material) return;
      var mats = Array.isArray(child.material) ? child.material : [child.material];
      mats.forEach(function (mat) {
        if (mat.color) { var hsl = {}; mat.color.getHSL(hsl); mat.color.setHSL(0, 0, hsl.l); }
        mat.onBeforeCompile = function (shader) {
          shader.fragmentShader = shader.fragmentShader.replace(
            '#include <dithering_fragment>',
            'float g=dot(gl_FragColor.rgb,vec3(0.299,0.587,0.114));gl_FragColor.rgb=vec3(g);\n#include <dithering_fragment>'
          );
        };
        mat.needsUpdate = true;
      });
    });
  }

  function computeFov(w) { return w < 750 ? 62 : 36; }

  function initScene(root) {
    var dataEl = root.querySelector('[data-city-data]');
    var canvasHost = root.querySelector('[data-city-canvas-host]');
    var labelEl = root.querySelector('[data-city-label]');
    var labelTextEl = root.querySelector('[data-city-label-text]');
    var prevBtn = root.querySelector('[data-city-prev]');
    var nextBtn = root.querySelector('[data-city-next]');
    if (!dataEl || !canvasHost) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var buildings = data.buildings || [], count = buildings.length;
    if (!count) return;

    var radius = 11, step = 360 / count;
    var scene = new THREE.Scene();
    /* Pas de fog, pas de ciel, fond transparent = fond CSS du site */

    var width = canvasHost.clientWidth, height = canvasHost.clientHeight;
    var camera = new THREE.PerspectiveCamera(computeFov(width), width / height, 0.1, 300);
    camera.position.set(0, 1.65, 0);

    var renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    renderer.setClearColor(0x000000, 0); /* fond totalement transparent */
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setSize(width, height);
    canvasHost.appendChild(renderer.domElement);

    scene.add(new THREE.HemisphereLight(0xbcd6dd, 0x05060a, 0.9));
    var sun = new THREE.DirectionalLight(0xffffff, 1.0); sun.position.set(8, 14, 6); scene.add(sun);
    var fill = new THREE.DirectionalLight(0x83baca, 0.22); fill.position.set(-10, 4, -8); scene.add(fill);

    var cityGroup = new THREE.Group();
    scene.add(cityGroup);
    /* Pas de buildSky, pas de buildStars — fond transparent */
    cityGroup.add(buildRockField(THREE, radius));

    var groundMat = new THREE.MeshStandardMaterial({ color: 0x11131a, roughness: 1 });
    var ground = new THREE.Mesh(new THREE.CircleGeometry(radius + 6, 48), groundMat);
    ground.rotation.x = -Math.PI / 2; cityGroup.add(ground);
    var outerGround = new THREE.Mesh(new THREE.CircleGeometry(radius + 70, 48),
      new THREE.MeshStandardMaterial({ color: 0x0f1013, roughness: 1 }));
    outerGround.rotation.x = -Math.PI / 2; outerGround.position.y = -0.02; cityGroup.add(outerGround);

    if (data.groundTexture) {
      new THREE.TextureLoader().load(data.groundTexture, function (tex) {
        tex.wrapS = tex.wrapT = THREE.RepeatWrapping; tex.repeat.set(4, 4);
        groundMat.map = tex; groundMat.color.set(0x6b6e76); groundMat.needsUpdate = true; render();
      });
    }

    var buildingMeshes = [], rotation = 0, velocity = 0, isDragging = false;
    var dragStartX = 0, dragStartRotation = 0, lastX = 0, lastT = 0;
    var rafId = null, currentFrontIndex = 0;

    function normalize(a) { a = a % 360; if (a > 180) a -= 360; if (a < -180) a += 360; return a; }
    function updateCamera() { cityGroup.rotation.y = (rotation * Math.PI) / 180; camera.lookAt(0, 1.65, -1); }
    function updateFrontLabel() {
      var closest = 0, closestDiff = 999;
      buildingMeshes.forEach(function (m, i) { var dv = Math.abs(normalize(m.angle - rotation)); if (dv < closestDiff) { closestDiff = dv; closest = i; } });
      if (closest !== currentFrontIndex || !labelEl.dataset.ready) {
        currentFrontIndex = closest;
        var meta = buildingMeshes[closest];
        labelTextEl.textContent = meta.label;
        labelEl.classList.toggle('city-scene__label--built', !!meta.built);
        labelEl.dataset.ready = '1';
        labelEl.onclick = meta.built && meta.url ? function () { window.location.href = meta.url; } : null;
        labelEl.style.cursor = meta.built && meta.url ? 'pointer' : 'default';
      }
    }
    function render() {
      updateCamera(); updateFrontLabel();
      var speed = Math.min(Math.abs(velocity), 30);
      renderer.domElement.style.filter = speed > 1.5 ? 'blur(' + Math.min(speed * 0.2, 5).toFixed(1) + 'px)' : 'none';
      renderer.render(scene, camera);
    }

    buildings.forEach(function (b) {
      var ar = (b.angle * Math.PI) / 180;
      var slot = new THREE.Group();
      slot.position.set(Math.sin(ar) * radius, 0, -Math.cos(ar) * radius);
      slot.rotation.y = ar;
      cityGroup.add(slot);
      buildingMeshes.push({ built: b.built, url: b.url, label: b.label, angle: b.angle });
      if (b.built) {
        var kl = new THREE.PointLight(0xffffff, 2.2, 16, 2); kl.position.set(0.5, 3.6, 2.6); slot.add(kl);
        var rl = new THREE.PointLight(0x9fd0db, 0.9, 12, 2); rl.position.set(-2.2, 2.2, -1.4); slot.add(rl);
      }
      if (b.modelUrl) {
        new THREE.GLTFLoader().load(b.modelUrl, function (gltf) {
          var model = gltf.scene;
          desaturateModel(THREE, model);
          var box = computeMeshBoundingBox(THREE, model);
          var sz = new THREE.Vector3(); box.getSize(sz);
          var ctr = new THREE.Vector3(); box.getCenter(ctr);
          var inner = new THREE.Group(); inner.add(model);
          model.position.x -= ctr.x; model.position.y -= box.min.y; model.position.z -= ctr.z;
          inner.scale.setScalar((b.built ? 5.5 : 1.4) / (Math.max(sz.x, sz.y, sz.z) || 1));
          if (!b.built) inner.scale.y *= 0.45;
          inner.position.y -= 0.1;
          slot.add(inner); render();
        }, undefined, function () { slot.add(buildPlaceholder(THREE, b.variant, b.built)); render(); });
      } else {
        slot.add(buildPlaceholder(THREE, b.variant, b.built));
      }
    });

    function settle() {
      if (Math.abs(velocity) > 0.04 && !isDragging) { rotation += velocity; velocity *= 0.92; render(); rafId = requestAnimationFrame(settle); }
      else if (!isDragging) {
        velocity = 0;
        var target = Math.round(rotation / step) * step, diff = target - rotation;
        if (Math.abs(diff) > 0.05) { rotation += diff * 0.16; render(); rafId = requestAnimationFrame(settle); }
        else { rotation = target; render(); }
      }
    }
    function onPointerDown(e) { isDragging = true; dragStartX = e.clientX; dragStartRotation = rotation; lastX = e.clientX; lastT = performance.now(); velocity = 0; if (rafId) cancelAnimationFrame(rafId); }
    function onPointerMove(e) {
      if (!isDragging) return;
      rotation = dragStartRotation - (e.clientX - dragStartX) * 0.25;
      var now = performance.now(), dt = now - lastT;
      if (dt > 0) velocity = (-(e.clientX - lastX) * 0.25) / (dt / 16.6);
      lastX = e.clientX; lastT = now; render();
    }
    function onPointerUp() { if (!isDragging) return; isDragging = false; rafId = requestAnimationFrame(settle); }

    canvasHost.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);
    window.addEventListener('pointercancel', onPointerUp);
    canvasHost.style.cursor = 'grab';
    canvasHost.addEventListener('pointerdown', function () { canvasHost.style.cursor = 'grabbing'; });
    window.addEventListener('pointerup', function () { canvasHost.style.cursor = 'grab'; });
    if (prevBtn) prevBtn.addEventListener('click', function () { rotation -= step; velocity = 0; render(); rafId = requestAnimationFrame(settle); });
    if (nextBtn) nextBtn.addEventListener('click', function () { rotation += step; velocity = 0; render(); rafId = requestAnimationFrame(settle); });

    new ResizeObserver(function () {
      var w = canvasHost.clientWidth, h = canvasHost.clientHeight;
      if (!w || !h) return;
      renderer.setSize(w, h); camera.aspect = w / h; camera.fov = computeFov(w); camera.updateProjectionMatrix(); render();
    }).observe(canvasHost);

    render();
    (function loop() { render(); requestAnimationFrame(loop); })();
  }

  function init() {
    var roots = document.querySelectorAll('[data-city-scene]');
    if (!roots.length) return;
    whenThreeReady(function () { roots.forEach(initScene); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
